import * as React from "react";
import { Facebook, Instagram, Twitter, Youtube, Linkedin } from "lucide-react";
import { Link } from "@/components/common/Link";
import { WvcLogo } from "@/integrations/wordpress/WvcLogo";
import { Button } from "@/components/ui/button";
const socialLinks = [{
  name: "Facebook",
  icon: Facebook,
  href: "https://wa.me/526149800517"
}, {
  name: "Instagram",
  icon: Instagram,
  href: "https://wa.me/526149800517"
}, {
  name: "Youtube",
  icon: Youtube,
  href: "https://wa.me/526149800517"
}, {
  name: "Linkedin",
  icon: Linkedin,
  href: "https://wa.me/526149800517"
}];
const companyLinks = [{
  title: "Acerca de nosotros",
  href: "/KalischSteelPage"
}, {
  title: "Misión y visión",
  href: "#"
}, {
  title: "Código de ética",
  href: "#"
}, {
  title: "Cultura",
  href: "#"
}, {
  title: "Bolsa de trabajo",
  href: "#"
}];
export default function FooterAbadi() {
  const currentYear = new Date().getFullYear();
  return;
}